import { inject, Injectable } from '@angular/core';
import { Store } from '@sama/app-state';
import { removeKeyframe } from '../../../cross-team-shared/annotation/shared/utils/keyframe-utils';
import {
  FrameSpecificTag,
  Point2D,
} from '../../../team-apis/otterdam/answers/shape-typings';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';
import { RootUndoService } from '../misc-services/root-undo.service';
import { ContextMenuService } from './context-menu.service';

@Injectable()
export class AttributeContextMenuService {
  private contextMenuService = inject(ContextMenuService);
  private undoService = inject(RootUndoService);
  private taskWorkspaceStore = inject(TaskWorkspaceStore);

  async open(
    clientPoint: Point2D,
    dynamicTagStore: Store<FrameSpecificTag[]>,
    frameNumber: number,
  ) {
    const menuOptions = this.getAttributeContextMenuOptions(
      dynamicTagStore,
      frameNumber,
    );
    this.contextMenuService.open(menuOptions, clientPoint);
  }

  getAttributeContextMenuOptions(
    dynamicTagStore: Store<FrameSpecificTag[]>,
    frameNumber: number,
  ) {
    return [
      {
        label: 'Remove dynamic tag',
        action: () => {
          removeKeyframe(dynamicTagStore, frameNumber);
          this.undoService.pushCurrentState();
        },
        hidden: this.taskWorkspaceStore.state().readOnly,
      },
    ];
  }
}
